import React from 'react'
import classNames from 'classnames'

import styles from './ClearFormFieldButton.module.css'

const ClearFormFieldButton = ({ className, onClick }) =>
  <div onClick={onClick}>
    <span
      className={classNames('fa-stack', styles.clearFormFieldButton, className)}
    >
      <i className="fa fa-circle fa-stack-2x" />
      <i className="fa fa-remove fa-stack-1x fa-inverse" />
    </span>
  </div>

export default ClearFormFieldButton
